module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/hall-list/plan-ceremony-lineup-kanto-1-a728f4ceb310719ded4785895c2cade5.png";